import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import Decimal from '~/modules/common/components/Decimal';
import { isNullOrUndefined } from '~/modules/common/util';
import { themeWithoutDir as theme } from '~/modules/App/withRootTheme';

const useStyles = makeStyles({
  value: {
    fontWeight: 600,
    fontSize: theme.spacing(1.75)
  },
  noValue: {
    fontWeight: 400
  }
});

export const CostVariationFormatter = ({ field, record }) => {
  const classes = useStyles();
  const value = record[field];

  return isNullOrUndefined(value) ? (
    <FormattedMessage id="taskDrawer.na" />
  ) : (
    <Decimal
      className={value !== 0 ? classes.value : classes.noValue}
      value={value}
      prefix={record.costPrefix}
      fixedDecimalScale
    />
  );
};

CostVariationFormatter.propTypes = {
  field: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired
};

export default CostVariationFormatter;
